import { TemplateSummaryOutputs } from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.types'

export type SummaryMetric = {
  key: keyof TemplateSummaryOutputs
  label: string
  value: string
  unit?: string
}

const format = (value: number, unit?: string) => {
  // Backend persists percentages as fractions (0–1); scale for display.
  const isPct = unit === '%'
  const scaled = isPct ? value * 100 : value
  return scaled.toFixed(isPct ? 1 : 2)
}

const metric = (
  summary: TemplateSummaryOutputs,
  key: keyof TemplateSummaryOutputs,
  label: string,
  unit?: string
): SummaryMetric => {
  const raw = summary[key]
  return {
    key,
    label,
    value: typeof raw === 'number' ? format(raw, unit) : String(raw ?? '—'),
    unit,
  }
}

/** The ten summary figures for a template, in display order. */
export const templateSummaryMetrics = (
  summary: TemplateSummaryOutputs
): SummaryMetric[] => [
  metric(summary, 'avgChangeOversPerWeek', 'Avg changeovers / week'),
  metric(
    summary,
    'avgUtilisationHoursNonFOQPerWeek',
    'Avg utilisation (non-FOQ) / week',
    'h'
  ),
  metric(summary, 'avgChangeOverPerProduct', 'Avg changeover per product'),
  metric(summary, 'weightedAvgRunRate', 'Weighted avg run rate'),
  metric(summary, 'avgCycleSpeed', 'Avg cycle speed'),
  metric(summary, 'percentageChangeOver', 'Changeover', '%'),
  metric(summary, 'utilisationVolatility', 'Utilisation volatility', '%'),
  metric(summary, 'maxHours', 'Max hours', 'h'),
  metric(summary, 'workcentreCapacityInitial', 'Initial capacity', 'h'),
  metric(summary, 'adjustedCapacity', 'Adjusted capacity'),
]
